import { Component, OnInit, ViewChild } from '@angular/core';
import { certState, FieldSupervisor } from '../../shared/models/fsupervisor.model';
import { FSupervisorService } from '../../services/supervisor.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { GlobalService } from '../../services/global.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { CompanyEnum } from 'src/app/shared/enums/company.enum';

@Component({
    selector: 'app-select-supervisor',
    templateUrl: './select-supervisor.component.html',
    styleUrls: ['./select-supervisor.component.scss']
})
export class SelectSupervisorComponent implements OnInit {

    displayedColumns: string[] = ['FieldSupervisorId', 'FirstName', 'LastName', 'PrimaryEmail', 'Program', 'States'];
    supervisors: FieldSupervisor[] = [];
    dataSource: any;
    showLoading = false;
    loggedUserEmail: string;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    constructor(private supervisorService: FSupervisorService,
        private authService: AuthService,
        private router: Router,
        private globalService: GlobalService,
        private themeService: ThemeService) {
    }

    ngOnInit() {
        if (this.authService.authenticated) {
            this.authService.getUser().then(user => {
                console.log(user);
                this.themeService.setTheme(user.companyId);
            });
        }
        else {
            this.router.navigate(['auth']);
        }
        this.searchSupervisors();
    }

    private searchSupervisors() {
        this.showLoading = true;
        this.supervisorService.getAvailableFieldSupervisors().subscribe(data => {

            //find logged user email in supervisor
            let findSupervisor = data.find(x => x.PrimaryEmail === this.loggedUserEmail)
            if (findSupervisor != undefined) {
                //TODO: Check roles

                //Set global variable supervisor
                this.globalService.supervisor = findSupervisor;

                //Indicate this is NOT an impersonation
                this.globalService.impersonated = false;

                //Redirect to intern search
                this.router.navigate(['intern-search']);
            }

            this.supervisors = data;
            this.dataSource = new MatTableDataSource<FieldSupervisor>(this.supervisors);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;

            // Custom sorting for the Program column
            this.dataSource.sortingDataAccessor = (item: FieldSupervisor, property: string) => {
                if (property === 'Program') {
                    return this.getCompanyName(item.CertStates);
                }
                return item[property];
            };

            this.showLoading = false;
        });
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    select(supervisor: any) {
        console.log(supervisor);

        //Set global variable supervisor
        this.globalService.supervisor = supervisor;

        //Indicate this is an impersonation        
        this.globalService.impersonated = true;

        //Redirect to intern search
        this.router.navigate(['intern-search']);
    }

    getCompanyName(certStates: certState[]): string {
        const companyId = certStates[0]?.companyId;
        if (!companyId) {
            return '';
        }
        return CompanyEnum[companyId];
    }

    getStates(certStates: certState[]): string {
        return certStates.map(state => state.stateCode).join(', ');
    }
}
